import { render, staticRenderFns } from "./SPCompanyEmailVerification.vue?vue&type=template&id=29b1f0ec&scoped=true"
import script from "./SPCompanyEmailVerification.vue?vue&type=script&lang=js"
export * from "./SPCompanyEmailVerification.vue?vue&type=script&lang=js"
import style0 from "./SPCompanyEmailVerification.vue?vue&type=style&index=0&id=29b1f0ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b1f0ec",
  null
  
)

export default component.exports